exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".l0cBXt9_KRr-DC{width:100%}", ""]);

// exports
exports.locals = {
	"stop": "l0cBXt9_KRr-DC"
};